import { gql } from 'apollo-boost';
import { ProjectQueries } from "@src/queries/ProjectQueries";

export const fragments = {

	CURRENT_USER: {
		QUERY_RETURN: `
			id
			firstName
			lastName
			emailAddress
			businessFunctions
			systemRole
			organizations{
				isActive
				organizationId
				organizationRole
			}
			projects{
				project{
					id
					organizationId
					name
					isDiscoveryComplete
					isActive
					isCorvalManaged
					projectVersions {
					    ${ ProjectQueries.fragments.PROJECTS.VERSION_DETAIL_FIELDS }
					}
				}
				projectId
				projectRole
			}
			createdUtc`
	},

	USER: {
		QUERY_RETURN: `
			id
			firstName
			lastName
			emailAddress
			businessFunctions
			organizations {
				isActive
				organizationId
				organizationRole
			}
			projects{
				project{
					id
					organizationId
					name
				}
				projectId
				projectRole
			}
			systemRole
			updatedUtc`,

		EDIT_FIELDS: `
			id
			firstName
			lastName
			emailAddress
			systemRole
			businessFunctions
			organizations {
				isActive
				organizationId
				organizationRole
			}
		`
	}
};

export const queries = {

	GET_CURRENT_USER: ( returnQueryString = fragments.CURRENT_USER.QUERY_RETURN ) => gql`
        query GetCurrentUser{
            me { ${ returnQueryString } }
        }`,

	GET_USERS: ( returnQueryString = fragments.USER.QUERY_RETURN ) => gql`
        query GetUsers( $order: [AccountSortInput!], $where: AccountFilterInput ){
            accounts( order: $order, where: $where){
                ${ returnQueryString }
            }
        }`,

	GET_USER: ( returnQueryString = fragments.USER.QUERY_RETURN ) => gql`
        query GetUser( $id: Uuid! ){
            accounts( where: { id: { eq: $id } } )  {
                ${ returnQueryString }
            }
        }`
};

export const mutations = {

	CREATE_USER_ACCOUNT: ( returnQueryString = fragments.USER.QUERY_RETURN ) => gql`
        mutation CreateUserAccount( $input : AccountCreateCommandInput! ){
            createAccount( input:$input ){
                ${ returnQueryString }
            }
        }`,

	UPDATE_USER_ACCOUNT: ( returnQueryString = fragments.USER.QUERY_RETURN ) => gql`
        mutation UpdateUserAccount( $input : AccountUpdateCommandInput! ){
            updateAccount( input:$input ){
                ${ returnQueryString }
            }
        }`
};

export const UserQueries = {
	fragments,
	queries,
	mutations,
};
